module.exports = __webpack_public_path__ + "img/icon-payment-bandes.4606517b.png";